module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "dialog",
    on: {
      "close": _vm.close
    }
  }, [_c('mu-card', [_c('mu-card-text', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Show Macronutrients percentage:")]), _vm._v(" "), _c('mu-col', [_c('mu-row', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('mu-col', [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Based on food weight consumed")]), _vm._v(" "), _c('p', [_vm._v("Recommended if you’re basing your daily intake\n            on numbers you see on food labelling.")])]), _vm._v(" "), _c('mu-col', [_c('mu-radio', {
    attrs: {
      "value": "g",
      "native-value": "g"
    },
    model: {
      value: (_vm.unit),
      callback: function($$v) {
        _vm.unit = $$v
      },
      expression: "unit"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Based on the nutrient’s density")]), _vm._v(" "), _c('p', [_vm._v("Recommended for advanced members who prefer\n            to see calorie breakdown by nutritional density.")])]), _vm._v(" "), _c('mu-col', [_c('mu-radio', {
    attrs: {
      "value": "kcal",
      "native-value": "kcal"
    },
    model: {
      value: (_vm.unit),
      callback: function($$v) {
        _vm.unit = $$v
      },
      expression: "unit"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.cancelText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hide.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.updateText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.update.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d06a41c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FoodDiary/NutritionUnitDialog/NutritionUnitDialog.vue
// module id = 3293
// module chunks = 1